const background = require("./background.jpg");
const profile = require("./profile.png");
const blogImg1 = require("./div1.png");
const blogImg2 = require("./div2.png");
const blogImg3 = require("./div3.png");
const a1 = require("./a1 (1).png");
const a2 = require("./a1 (2).png");
const a3 = require("./a1 (3).png");
const a4 = require("./a1 (4).png");
const a5 = require("./a1 (5).png");
const a6 = require("./a1 (6).png");
const me1 = require("./me.jpg");
const me2 = require("./me2.jpg");
const luqmoniHakim = require("./luqmoniHakim.png");
const istanbulCity = require("./istanbulCity.png");
const bvir = require("./bvir.jpg");
const bviradmin = require("./adminBvir.jpg");
const grm = require("./grm.png");

export {
  background,
  profile,
  blogImg1,
  blogImg2,
  blogImg3,
  a1,
  a2,
  a3,
  a4,
  a5,
  a6,
  me1,
  me2,
  luqmoniHakim,
  istanbulCity,
  bvir,
  grm,
  bviradmin
};
